var map = {
	"./training-1.jpg": "QQvI",
	"./training-10.jpg": "ZQln",
	"./training-11.jpg": "R8Tm",
	"./training-12.jpg": "rab3",
	"./training-2.jpg": "xi1y",
	"./training-3.jpg": "AcAe",
	"./training-4.jpg": "pflM",
	"./training-5.jpg": "IMei",
	"./training-6.jpg": "I08b",
	"./training-7.jpg": "9jfT",
	"./training-8.jpg": "sXV+",
	"./training-9.jpg": "Gpma"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9Snh";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/KishoreTraining/Kishore-pics ^\.\/.*$
// module id = 9Snh
// module chunks = 0